module.exports = __webpack_public_path__ + "img/message.e5333e2e.svg";